import { SearchPage } from './search-page.model';
import { SiteContact } from './SiteContact.model';

export class SiteContactList extends SearchPage {
  results: SiteContact[]
}
